import { get } from '../../utils/objectHelpers';

export default class {
    onCreate(input) {
        this.breakpointLarge = 1280; // @breakpoint-large
        this.defaultCarouselHeight = (9 / 16) * 400;

        let itemsPerSlide = 1;
        const m = get(input, 'page.modules', {});
        const mediaContent = m.ABOUT_VIDEO_MODULE;
        const video = get(mediaContent, 'video', null);
        const description = m.ABOUT_DESCRIPTION_MODULE;
        const mediaList = this.buildMediaList([video], mediaContent);
        this.reportUrl = get(mediaContent, 'reportAction.action.URL');
        this.reportTracking = get(mediaContent, 'reportAction.action.trackingList.[0]');
        const isSmall = get(input, 'page.isSmall', false);

        if (this.couldItemsPerSlideBeTwo(mediaList, description)) {
            itemsPerSlide = 2;
        }
        this.state = {
            itemsPerSlide: itemsPerSlide,
            description: description,
            mediaList: mediaList,
            mobileCarouselHeight: this.defaultCarouselHeight,
            isSmall: isSmall
        };
    }
    onMount() {
        this.handleItemsPerSlide();
        this.handleStoppingVideoOnTabChange();
        this.handleMobileCarouselHeight();
        this.preventVideoFullScreenOnSafari();
    }
    onUpdate() {
        this.handleStoppingVideoOnTabChange(); // Need this for browser width less than 1280px
    }
    handleResize() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => { // Debounce
            if (!document.fullscreenElement) {
                this.handleItemsPerSlide();
            }
        }, 50);
    }
    handleItemsPerSlide() {
        if (this.couldItemsPerSlideBeTwo()) {
            this.state.itemsPerSlide = window.innerWidth >= this.breakpointLarge ? 2 : 1;
        }
    }
    handleMobileCarouselHeight() {
        if (this.state.isSmall) {
            const mql = window.matchMedia('(orientation: portrait)'); // Device orientation (not video orientation).
            if (mql.matches) { // portrait
                this.state.mobileCarouselHeight = (9 / 16) * window.innerWidth;
            } else {
                this.state.mobileCarouselHeight = this.defaultCarouselHeight;
            }
        }
    }
    sendTracking(tracking) {
        if (tracking) {
            document.dispatchEvent(new CustomEvent('pulsar', { detail: tracking }));
        }
    }
    navigateToReport(tracking) {
        if (tracking) {
            const event = new CustomEvent('pulsar', { detail: tracking });
            document.dispatchEvent(event);
        }
        if (this.reportUrl) {
            window.open(this.reportUrl, '_blank');
        }
    }
    couldItemsPerSlideBeTwo(_mediaList, _description) {
        let mediaList = _mediaList;
        let description = _description;
        if (!mediaList) {
            mediaList = this.state.mediaList;
            description = this.state.description;
        }
        return !!((mediaList.length && description) || mediaList.length > 1);
    }
    buildMediaList(mediaList, mediaModule) {
        const list = [];
        if (mediaList) {
            for (let i = 0, n = mediaList.length; i < n; i++) {
                const media = mediaList[i];
                if (media && media.playlistMap) {
                    const sources = [];
                    if (media.playlistMap.DASH) {
                        sources.push({ url: media.playlistMap.DASH, type: 'dash' });
                    }
                    if (media.playlistMap.HLS) {
                        sources.push({ url: media.playlistMap.HLS, type: 'hls' });
                    }
                    if (sources.length) {
                        list.push({
                            sources: sources,
                            thumbnail: get(media, 'thumbnail.URL', ''),
                            text: this.getMediaText(media, mediaModule),
                            tracking: get(media, 'videoControlsMap.PLAY.trackingList.0', {})
                        });
                    }
                }
            }
        }
        return list;
    }
    getMediaText(media, mediaModule) {
        return {
            a11y: {
                play: get(media, 'videoControlsMap.PLAY.accessibilityText', ''),
                pause: get(media, 'videoControlsMap.PAUSE.accessibilityText', ''),
                mute: get(media, 'videoControlsMap.MUTE.accessibilityText', ''),
                volume: get(media, 'videoControlsMap.VOLUME.accessibilityText', ''),
                fullScreen: get(media, 'videoControlsMap.FULL_SCREEN.accessibilityText', ''),
                seek: get(media, 'videoControlsMap.SEEK.accessibilityText', ''),
                report: get(mediaModule, 'reportAction.textSpans.[0].text', ''),
                loading: get(media, 'loadingMessage.textSpans.0.text', '')
            },
            loading: get(media, 'loadingMessage.textSpans.0.text', ''),
            errorMessage: get(media, 'errorMessage.textSpans.0.text', ''),
            report: get(mediaModule, 'reportAction.textSpans.[0].text', '')
        };
    }
    handleStoppingVideoOnTabChange() {
        if (this.el) { // TODO: See why this.el check is needed. Tests fail if not included.
            const allVideoEls = this.el.querySelectorAll('video');
            document.addEventListener('str-tab-change-event', data => {
                const tabIndex = get(data, 'detail.tabIndex');
                if (tabIndex !== 1) { // Video is only visible on tabIndex 1
                    allVideoEls.forEach(vid => {
                        vid.pause();
                    });
                }
            });
        }
    }
    preventVideoFullScreenOnSafari() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
            this.el.addEventListener('dblclick', (evt) => {
                const cls = evt.target.getAttribute('class');
                if (cls.indexOf('shaka-') !== -1) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
            }, true); // capturing phase!!
        }
    }
}
